import { padding16 } from "@/components/Styles"
import LoginCircularProgress from "@/components/utils/LoginCircularProgress"
import { Typography } from "@mui/material"

const chunkReloadKey = "chunkReloadCount"

function handleReload() {
  const maxChunkReload = 3
  const chunkReloadCount = Number.parseInt(localStorage.getItem(chunkReloadKey), 10) || 0

  if (chunkReloadCount && chunkReloadCount >= maxChunkReload) {
    return (
      <Typography style={padding16}>
        Sorry. We were unable to load this part of the page. Please try again.
      </Typography>
    )
  }
  localStorage.setItem(chunkReloadKey, chunkReloadCount + 1)
  window.location.reload()
  return <LoginCircularProgress />
}

export function UnableToLoad() {
  const reloadText = handleReload()

  return <div>{reloadText}</div>
}

export const clearReload = () => {
  if (localStorage.getItem(chunkReloadKey)) {
    localStorage.removeItem(chunkReloadKey)
  }
}
